export default "__VITE_ASSET__DqE1iRt9__"